// @mui
import { Box, List, ListSubheader } from "@mui/material";
import { styled } from "@mui/material/styles";
// type
import { NavSectionProps } from "../type";
//
import { NavListRoot } from "./NavList";
import useAuth from "~src/hooks/useAuth";

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.overline,
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.primary,
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

export default function NavSectionVertical({
  navConfig,
  isCollapse = false,
  ...other
}: NavSectionProps) {
  const { user } = useAuth();
  const is_superuser = user?.is_superuser;
  return (
    <Box sx={{ overflow: "auto" }} {...other} data-testid={"sideNav"}>
      {navConfig.map((group) => (
        <List key={group.subheader} disablePadding sx={{ px: 2 }}>
          {group.items.map((list) => {
            if (
              !is_superuser &&
              (list.path === "/brands/add-brand")
            ) {
              return null;
            }
            return (
              <NavListRoot
                key={list.title + list.path}
                list={list}
                isCollapse={isCollapse}
              />
            );
          })}
        </List>
      ))}
    </Box>
  );
}
